export { default as IndexPagination } from './IndexPagination';



// WEBPACK FOOTER //
// ./src/components/IndexPagination/index.ts